const mgnlToJson = (obj) => {
  return obj['@nodes'].map((key) => obj[key])
}

export { mgnlToJson }
